// extracted by mini-css-extract-plugin
export default {"textarea":"textarea_textarea__TY12c","description":"textarea_description__cRxwi","label":"textarea_label__8RU5l","error":"textarea_error__GNdvM"};